import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Organization } from '../store';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators/map';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class ClubTeamsService {


  private _links = [];
  private _mainLink = { title: 'ClubTeams', url: '/clubteams' };

  private _api = '/api/clubteams';
  private _tgsMasterbackend = '/api/tgsmasterbackend';

  links: { title: string; url: any; }[];

  constructor(
    private httpService: HttpService,
    private http: HttpClient,
  ) { }

  getTeamsCounts(clubID: number, typeID: number) {
    return this.httpService.get(`${this._api}/get-club-teams-counts/${clubID}/${typeID || 1}`);
  }

  getClubTeamsList(clubID: number, status: number, typeID: number = 1) {
    return this.httpService.get(`${this._api}/get-club-teams-list/${status}/${clubID}/${typeID}`);
  }

  getClubTeamsListWithArchivedTeams(clubID: number, typeID: number = 1) {
    return this.httpService.get(`${this._api}/get-club-teams-list-with-archived-teams/${clubID}/${typeID}`);
  }
  
  getClubTeamListByClubIDAndTeamTypeID(clubID: number, typeID: number = 1) {
    return this.httpService.get(`${this._api}/get-club-team-list-by-clubid-and-team-typeid/${clubID}/${typeID}`);
  }

  getTeamsList(clubID: number, orgID: number, orgSeasonID: number, status: number) {
    return this.httpService.get(`${this._api}/get-org-club-team-list/${status}/${orgID}/${clubID}/${orgSeasonID}`);
  }

  removeClubTeams(cupfIDs: string, clubID: number) {
    return this.httpService.post(this._api + '/remove-club-teams', { TeamIDs: cupfIDs, ClubID: clubID });
  }

  archiveClubTeams(teamIds: string, clubID: number, status = 0) {
    return this.httpService.post(this._api + `/archive-club-teams/${status}`, { TeamIDs: teamIds, ClubID: clubID });
  }

  getClubTeamPlayersList(clubID: number, teamID: number, status: number) {
    return this.httpService.get(`${this._api}/get-club-team-players-list/${status}/${clubID}/${teamID}`);
  }

  addTeam(clubID: number, data) {
    return this.httpService.post(this._api + `/add-team/${clubID}`, data);
  }

  sendEmail(clubId: number, data) {
    return this.httpService.post(`${this._api}/send-email/${clubId}`, data);
  }

  removePlayers(teamId: number, adminUserID: number, players: number[]) {
    return this.httpService.post(`${this._api}/remove-players/${teamId}/${adminUserID}`, players);
  }

  getClubListWithPlayerAndStaffCount() {
    return this.httpService.get(`${this._tgsMasterbackend}/get-club-list-with-player-and-staff-count`);
  }

  getAllIssueByTGSSystemID(systemID: number) {
    return this.http.get(this._tgsMasterbackend + '/get-all-issue-by-tgs-systemID/' + systemID);
  }

  getTGSSystemIssueHistoryByIssueID(tgsSystemIssueID: number) {
    return this.http.get(this._tgsMasterbackend + '/get-tgs-system-issue-history-by-issueID/' + tgsSystemIssueID);
  }

  getTGSSystemOverallStatusList() {
    return this.http.get(this._tgsMasterbackend + '/get-tgs-system-overall-status');
  }

  getTgsSystemUpdateListByTgsSystemID(tgsSystemID: number) {
    return this.http.get(this._tgsMasterbackend + '/get-tgs-system-update-list-by-tgs-systemID/' + tgsSystemID);
  }

  getFirebaseProjectConfigDataByClubID(clubID: number) {
    return this.http.get(this._tgsMasterbackend + '/get-fire-base-project-config-data-by-clubID/' + clubID);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/club-teams.service.ts